/**
 * @generated SignedSource<<b698f83cf5da188a679aa42f35584a40>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ActorType = "GUILDS" | "USERS" | "%future added value";
export type EventHostStatus = "CONFIRMED" | "DECLINED" | "PENDING" | "%future added value";
export type GuildMembershipLevel = "EDITOR" | "MEMBER" | "ORGANIZER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventHostInvitationBanner_event$data = {
  readonly eventHosts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly host: {
          readonly __typename: "Guild";
          readonly myMembership: {
            readonly membershipLevel: GuildMembershipLevel;
          } | null | undefined;
          readonly name: string;
          readonly slugId: string;
        } | {
          readonly __typename: "User";
          readonly rowId: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
        readonly hostType: ActorType;
        readonly id: string;
        readonly rowId: string;
        readonly status: EventHostStatus;
      } | null | undefined;
    }>;
  };
  readonly " $fragmentType": "EventHostInvitationBanner_event";
};
export type EventHostInvitationBanner_event$key = {
  readonly " $data"?: EventHostInvitationBanner_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventHostInvitationBanner_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventHostInvitationBanner_event",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "status": {
              "equalTo": "PENDING"
            }
          }
        }
      ],
      "concreteType": "EventHostsConnection",
      "kind": "LinkedField",
      "name": "eventHosts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventHostsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventHost",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hostType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "host",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "slugId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "GuildMembership",
                          "kind": "LinkedField",
                          "name": "myMembership",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "membershipLevel",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "Guild",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "type": "User",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "eventHosts(filter:{\"status\":{\"equalTo\":\"PENDING\"}})"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "0e37fdde5f703fc0426e4dfde2176207";

export default node;
